import { pipe } from 'fp-ts/lib/function';
import { array, failure, parse, struct, success } from 'io-ts/Decoder';

import { Id as StepId } from '../../../../job/hitlv2/step/Id';
import { Status as StepStatus } from '../../../../job/hitlv2/step/Status';

import { RequestItem } from './RequestItem';

export const Request = pipe(
	struct({
		items: array(RequestItem),
		steps: array(
			struct({
				stepId: StepId,
				status: StepStatus,
			})
		),
	}),
	parse((v) =>
		v.items.length > 0 || v.steps.length > 0
			? success(v)
			: failure(v, 'items or steps array must not be empty')
	)
);
